
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/wisdom/search",
      function () {
        return require("private-next-pages/[region]/wisdom/search/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/wisdom/search"])
      });
    }
  